import { useEffect, useState } from 'react';
import { ProjectApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectWithClientInfo } from '../../../commonTypes/acs/project.types';

const transformProjectsWithAssignees = (projects: any) => {
    return projects.map((project: any) => ({
        ...project,
        projectAssignees: project.projectAssignees?.map((assignee: any) => assignee.userSub) || [],
    }));
};

const useHttpGetActiveClientsProjects = (clientId?: string) => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const [areProjectsReady, setAreProjectsReady] = useState<boolean>(false);
    const [projects, setProjects] = useState<ProjectWithClientInfo[]>([]);

    useEffect(() => {
        if (!clientId) return;
        const { exec, clearCache, abort } = projectApi.getAllActiveClientsProjects({
            params: {
                clientId,
            },
            onSuccess: res => {
                const transformed = transformProjectsWithAssignees(res.body);
                setProjects(transformed);
                clearCache();
            },
            onError: _ => console.log('Failed to fetch active projects from organization'),
            onFinally: () => setAreProjectsReady(true),
        });
        exec();
        return abort;
    }, [clientId]);

    return {
        projects,
        setProjects,
        areProjectsReady,
    };
};

export default useHttpGetActiveClientsProjects;
